<template>
    <div v-show="visible">
        <el-dialog title="流程步骤设置" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="750px">    
          
          <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAddProcedure()">新增流程步骤</el-button>
          <el-table
                :data="procedureData"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                border
                height="190"
                default-expand-all>
                <el-table-column prop="orderNum" label="步骤编号" width="80"> </el-table-column>
                <el-table-column prop="name" label="步骤名称" width="150">
                </el-table-column>
                <el-table-column prop="checkerType" label="审批人依据类型" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkerType == 1">
                            指定人员
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="checkerValueLabel" label="审核人依据值" :show-overflow-tooltip="true" width="200">
                 </el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setDelProcedure(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">删除步骤</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="color:red;font-size:13px;">注：步骤编号也就是审批顺序，从小到大审批。</div>

            <!-- <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAddTrend()">新增步骤流向</el-button>
            <el-table
                :data="proceduresTrendData"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                border
                height="190"
                default-expand-all>
                <el-table-column prop="orderNum" label="步骤编号" width="80"> </el-table-column>
                <el-table-column prop="start" label="起始步骤" width="250">
                    <template slot-scope="scope">
                        <div v-if="scope.row.start == 1">
                            [开始]
                        </div>
                        <div v-else>
                            {{scope.row.startLabel}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="end" label="目标步骤" width="250">
                    <template slot-scope="scope">
                        <div v-if="scope.row.end == 2">
                            [结束]
                        </div>
                        <div v-else>
                            {{scope.row.endLabel}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setDelProcedureTrend(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>  -->

            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">关 闭</el-button>
            </span>
        </el-dialog>
        
        <!-- 新增/修改弹出框 -->
        <div v-if="addProcedureVisible">
            <addProcedure ref="addProcedure"></addProcedure>
        </div>
        <!-- 新增/修改弹出框
        <div v-if="addProcedureTrendVisible">
            <addProcedureTrend ref="addProcedureTrend"></addProcedureTrend>
        </div> -->
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import addProcedure from './AddProcedure.vue';
    // import addProcedureTrend from './AddProcedureTrend.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                addProcedureVisible:false,
                // addProcedureTrendVisible:false,
                form:{
                    flowDesignId:"",
                    deptId:""
                },
                rules: {},
                procedureData:[],
                // proceduresTrendData:[]
            }
        },
        components: {
            addProcedure
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                this.form.flowDesignId=data.id;
                this.form.deptId=data.deptId;
                // 查询流程步骤
                this.getProcedureData(data.id);
                // 查询流程步骤流向
                // this.getProceduresTrendData(data.id);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 查询流程步骤
            getProcedureData(val){
                let url  = this.listFlowProcedureUrl;
                let data = {
                    flowDesignId:val
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.procedureData = res.data.list;  
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{

                });
            },
            // 弹出新增流程步骤
            setAddProcedure(){
                this.addProcedureVisible=true;
                let flowDesignId=this.form.flowDesignId;
                let deptId=this.form.deptId;
                this.$nextTick(() => {
                    this.$refs['addProcedure'].init(flowDesignId,deptId);
                });
            },
            // // 查询步骤流向
            // getProceduresTrendData(val){
            //     let url  = this.listFlowProceduresTrendUrl;
            //     let data = {
            //         flowDesignId:val
            //     };
                
            //     this.apiPost(url,data).then((res) => {
            //         if(res.status==200){
            //            this.proceduresTrendData = res.data.list;  
            //         }else{
            //             this.$commonFn.showTip(res.message,3);
            //         }
            //     },(err)=>{

            //     });
            // },
            // // 弹出新增步骤流向
            // setAddTrend(){
            //     this.addProcedureTrendVisible=true;
            //     let flowDesignId=this.form.flowDesignId;
            //     this.$nextTick(() => {
            //         this.$refs['addProcedureTrend'].init(flowDesignId);
            //     });
            // },
            //删除流程步骤
            setDelProcedure(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delProcedureSuccess);
            },
            delProcedureSuccess(){
                let url = this.flowProcedureRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        let flowDesignId=this.form.flowDesignId;
                        this.getProcedureData(flowDesignId);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // //删除流程步骤流向
            // setDelProcedureTrend(data){
            //     this.form.id = data.id;
            //     this.$commonFn.showConfirm(this.delProcedureTrendSuccess);
            // },
            // delProcedureTrendSuccess(){
            //     let url = this.flowProceduresTrendRemoveUrl;
            //     let data = {
            //         id:this.form.id
            //     };
            //     this.apiPost(url,data).then((res)=>{
            //         if(res.status === 200){
            //             this.$commonFn.showTip(res.message,1);
            //             let flowDesignId=this.form.flowDesignId;
            //             this.getProceduresTrendData(flowDesignId);
            //         }else{
            //             this.$commonFn.showTip(res.message,3);
            //         }
            //     },(err)=>{
            //         console.log(err);
            //     })
            // }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/flow/design/Update.vue